import { Divider, Text } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { ImageSelectionTile } from '~/components/image-selection-tile/components/image-selection-tile';
import { TileInformation } from '~/components/image-selection-tile/components/tile-information';
import {
	SubFamilyContainer,
	TileContainer,
} from '~/components/image-selection-tile/style/tile-selection-section-style';
import { RenderHtml } from '~/components/text';
import { FilteredItem } from '~/graphql/types';

interface SubFamilyProps {
	name: string;
	items: FilteredItem[];
	isLoading: boolean;
	handleItemSelection: (item: FilteredItem) => void;
	fallbackSVG: JSX.Element;
	lastItem: boolean;
}

export const SubFamily = ({ name, items, isLoading, handleItemSelection, fallbackSVG, lastItem }: SubFamilyProps) => {
	const { i18n } = useI18n();

	return (
		<SubFamilyContainer>
			<Text className="family-title" tag="p" variant={{ type: 'copy', order: '2', style: 'normal' }}>
				<RenderHtml html={name} />
			</Text>

			<div className="inner-container">
				{items.map((item) => (
					<TileContainer key={item.key}>
						<ImageSelectionTile
							altText={item.imgUrl ? item.name || '' : i18n('ngc.a11y.placeholderImage')}
							isLoading={item.loading}
							isSelected={item.selected}
							backgroundImage={item.imgUrl}
							disabled={isLoading || item.loading}
							onClick={() => handleItemSelection(item)}
							fallbackSVG={fallbackSVG}
						/>
						<TileInformation item={item} />
					</TileContainer>
				))}
			</div>
			{!lastItem && <Divider className="divider" />}
		</SubFamilyContainer>
	);
};
